import { z } from 'zod';

const requiredString = z
  .string()
  .trim()
  .min(1, 'payment.form.validation.required');

export const couponSchema = z.object({
  coupon: requiredString,
});
